/**
 * Geode Voice (UPT-2000 lot V0 §2) — visibilité du micro : add-on
 * `core-addon-voice` actif pour le locataire OU poste de développement
 * (`VITE_PROFILES_ACTIVE` vaut `local`).
 *
 * Revue CORE 11.10 : en local, le micro était caché tant que le drapeau
 * `localStorage` `geode.voice.mock = "1"` n'était pas posé à la main dans la
 * console, une fois par navigateur. Il est désormais toujours visible en
 * local ; sans configuration serveur, le bouton propose le simulateur. Le
 * drapeau reste lu (try/catch) pour démarrer directement en simulateur.
 */
import { isModuleCodeActive, type ActiveModuleRef } from '@/uptk/core/hooks/useActiveModules';

export const VOICE_MOCK_STORAGE_KEY = 'geode.voice.mock';
export const VOICE_ADDON_CODE = 'core-addon-voice';

/** Vrai quand le profil actif est local (démarrage direct en simulateur par drapeau localStorage). */
export const isLocalProfile = (): boolean => {
  const profile =
    (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_PROFILES_ACTIVE ??
    (typeof process !== 'undefined' ? process.env?.VITE_PROFILES_ACTIVE : undefined);
  return profile === 'local';
};

/** Drapeau du simulateur (lecture protégée : navigation privée, stockage plein). */
export const readVoiceMockFlag = (): boolean => {
  try {
    return window.localStorage.getItem(VOICE_MOCK_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

/** Vrai quand le bouton micro est visible pour ce locataire / ce poste. */
export const isVoiceVisible = (modules: ActiveModuleRef[]): boolean =>
  isModuleCodeActive(modules, VOICE_ADDON_CODE) || isLocalProfile();
